import styles from '../home.module.scss'
import { RiLoginCircleLine } from 'react-icons/ri'
import { motion } from "framer-motion"

export default function HeroSection({ user, error }: any) {

  return (
    <div className={styles.layout}>
      <motion.div className={styles.hero}
        initial={{ opacity: 0, x: -10 }} 
        animate={{ opacity: 1, x: 10 }} 
        transition={{ duration: 0.5 }}>
        <span style={{ fontSize: '40px', display: 'block' }}>
          Change your music listening with Dreamvast.
        </span>

        <span style={{ fontSize: '20px',  display: 'block' }}>
          Listen to music with Dreamvast with a music control panel and music filter for a more comfortable, convenient and fulfilling experience!
        </span>

        <a href={user && !error ? "/menu" : "/login"}>
          <div className={styles.button}>
            <RiLoginCircleLine size={30} color="#ffffff"/>
            <span>{ user && !error ? "My Servers" : "Login" }</span>
          </div>
        </a>
      </motion.div>

      <motion.div
      initial={{ opacity: 0, x: 10 }} 
      animate={{ opacity: 1, x: -10 }} 
      transition={{ duration: 0.5 }}>
        <motion.div
        animate={{ y: [-5,5,-5] }} 
        transition={{ duration: 2,repeat: Infinity }}>
          <img src="/logo.svg" alt="Logo" className={styles.logo}/>
        </motion.div>
      </motion.div>
    </div>
  )
}